import { smartDocParamResolver_FirstSmartDoc, smartDocParamResolver_FullName, smartDocParamResolver_LatestSmartDoc, smartDocParamResolver_MDM_NamesOfProtocols, smartDocParamResolver_MDM_ProtocolsNavigationSteps, smartDocParamResolver_Name, smartDocParamResolver_New, smartDocParamResolver_NextStep, smartDocParamResolver_Order_OrderName, smartDocParamResolver_Order_OrderType, smartDocParamResolver_Order_Subtype, smartDocParamResolver_Orders_DateTimeName, smartDocParamResolver_PhysicianNotes_DateTimeContent, smartDocParamResolver_PrettyPrint, smartDocParamResolver_ResolutionInfo, smartDocParamResolver_ShortName, SmartDocParamResolver_Time_CurrentTime, smartDocParamResolver_TransitionLabel, smartDocParamResolver_Unit, smartDocParamResolver_Value, smartDocParamResolver_Variable_Time, smartDocParamResolver_WorkingDiagnosis_Name } from './types.js';
export const smartDocParamResolverLabelMap = {
    //Variable Resolvers
    [smartDocParamResolver_PrettyPrint]: 'Pretty Print of',
    [smartDocParamResolver_Name]: 'Name of',
    [smartDocParamResolver_Variable_Time]: 'Time of',
    [smartDocParamResolver_Value]: 'Value of',
    [smartDocParamResolver_Unit]: 'Units of',
    //Template Resolvers
    [smartDocParamResolver_FirstSmartDoc]: 'First of',
    [smartDocParamResolver_LatestSmartDoc]: 'Latest of',
    [smartDocParamResolver_New]: 'New',
    //Navigation Response Resolvers
    [smartDocParamResolver_ShortName]: 'Short Name',
    [smartDocParamResolver_FullName]: 'Full Name',
    [smartDocParamResolver_NextStep]: 'Next Step',
    [smartDocParamResolver_TransitionLabel]: 'Transition Label',
    [smartDocParamResolver_ResolutionInfo]: 'Resolution Info',
    //Working Diagnosis Resolvers
    [smartDocParamResolver_WorkingDiagnosis_Name]: 'Name',
    //Order Resolvers
    [smartDocParamResolver_Order_OrderName]: 'Order Name',
    [smartDocParamResolver_Order_OrderType]: 'Order Type',
    [smartDocParamResolver_Order_Subtype]: 'Sub Type',
    //Physician Notes Resolvers
    [smartDocParamResolver_PhysicianNotes_DateTimeContent]: 'Date Time Content',
    //Orders Resolvers
    [smartDocParamResolver_Orders_DateTimeName]: 'Date Time Name',
    //MDM Resolvers
    [smartDocParamResolver_MDM_NamesOfProtocols]: 'Names of Protocols',
    [smartDocParamResolver_MDM_ProtocolsNavigationSteps]: 'Protocols Navigation Steps',
    //Time Resolvers
    [SmartDocParamResolver_Time_CurrentTime]: 'Current Time'
};
//# sourceMappingURL=consts.js.map